import * as React from 'react';
import styled from '@emotion/styled';
import MuiCheckbox from '@material-ui/core/Checkbox';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Magnetic as Mi } from "../../styles";
import { Box } from '@material-ui/core';
import { defaultTranslateFn } from "../../common";
const theme = createMuiTheme({
    palette: {
        secondary: { main: Mi.colorNeutral50 }
    },
    overrides: {
        MuiCheckbox: {
            root: {
                padding: Mi.spacer08
            }
        }
    }
});
const StyledCheckbox = styled(MuiCheckbox) `
	input {
		height: 100%;
		width: 100%;
	}
`;
const StyledCheckboxIcon = styled('span')((props) => `
	font-size: ${props.fontSize};
	color: ${props.disabled ? Mi.disabledBorderColor : props.color};
`);
const StyledLabel = styled('label')((props) => `
	font-size: ${props.fontSize};
	margin-bottom: -1px;
	color: ${props.disabled ? Mi.disabledFontColor : props.color};
	cursor: ${!props.disabled && Mi.actionableCursor};
	text-transform: ${props.textTransform || 'inherit'};
	user-select: none;
`);
const StyledRequiredLabel = styled('label') `
	color: ${Mi.validationErrorColor};
	margin-left: ${Mi.spacer04};
`;
/**
 * @param id [Optional] Id for the input element
 * @param checked Values that determine to checked status of checkbox
 * @param label [Optional] type of string or reactNode to display as label for checkbox.
 * @param className [Optional] css class name
 * @param disabled [Optional] If true, checkbox will be disabled, if false, behaves as normal
 * @param required [Optional] If true, checkbox will be required, if false, behaves as normal
 * @param indeterminate [Optional] - use this to display checkbox as indeterminate state
 * @param checkboxFontSize [Optional] override check box font size
 * @param labelFontSize [Optional] overrid label box font size
 * @param checkboxColor [Optional] ovrride check box Color
 * @param labelColor [Optional] overrid label color
 * @param shouldNotApplyMuiTheme [Optional] use this to apply mui theme
 * @param translateFn [Optional] use this to translate
 * @param onChange [Optional] callback method on checkbox state chanage
 **/
export class Checkbox extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const CheckboxComponent = props => (React.createElement(StyledCheckboxIcon, { className: props.className, fontSize: this.props.checkboxFontSize, color: this.props.checkboxColor, disabled: this.props.disabled }));
        const renderCheckbox = (React.createElement(React.Fragment, null,
            React.createElement(StyledCheckbox, { id: this.props.id, onChange: this.props.onChange, checked: this.props.checked, disabled: this.props.disabled, required: this.props.required, value: this.props.checked, indeterminate: this.props.indeterminate, icon: React.createElement(CheckboxComponent, { className: "mi-icon-checkbox" }), checkedIcon: React.createElement(CheckboxComponent, { className: "mi-icon-checkbox-checked" }), indeterminateIcon: React.createElement(CheckboxComponent, { className: 'mi-icon-dashbox' }), inputProps: { 'aria-label': this.props.ariaLabel } }),
            React.createElement(StyledLabel, { htmlFor: this.props.id, id: this.props.id + 'Label', fontSize: this.props.labelFontSize, color: this.props.labelColor, disabled: this.props.disabled, textTransform: this.props.textTransform },
                this.props.label,
                this.props.required && !this.props.checked && (React.createElement(StyledRequiredLabel, null, this.props.translateFn('* REQUIRED'))))));
        return (React.createElement(Box, { display: "flex", justifyContent: "flex-start", alignItems: "center", css: { margin: `-${Mi.spacer04} 0 0 -${Mi.spacer08}` } }, this.props.shouldNotApplyMuiTheme ? (renderCheckbox) : (React.createElement(MuiThemeProvider, { theme: theme }, renderCheckbox))));
    }
}
Checkbox.defaultProps = {
    id: '',
    label: '',
    className: '',
    disabled: false,
    indeterminate: false,
    checkboxFontSize: Mi.checkboxRadioCoreIconFontSize,
    labelFontSize: Mi.checkboxRadioCoreLabelFontSize,
    checkboxColor: Mi.checkboxRadioCoreIconColor,
    labelColor: Mi.checkboxRadioCoreLabelFontColor,
    shouldNotApplyMuiTheme: false,
    translateFn: defaultTranslateFn
};
//# sourceMappingURL=Checkbox.js.map